export type VaccinationRecordStatus = 'ADMINISTERED' | 'SCHEDULED' | 'REFUSED' | 'CONTRAINDICATED' | 'PARTIAL' | 'HISTORICAL';

export type VaccinationBodySide = 'LEFT' | 'RIGHT' | 'BILATERAL';

export type VaccineCatalogItem = {
  cvx: string;
  name: string;
  disease: string;
  routineSchedule: string;
};

export type VaccinationRecord = {
  id: string;
  organizationId: string;
  patientId: string;
  vaccineCode: string | null;
  vaccineName: string;
  disease: string | null;
  status: VaccinationRecordStatus;
  administrationDate: string | null;
  recordedDate: string | null;
  doseNumber: number | null;
  seriesDoses: number | null;
  booster: boolean;
  route: string | null;
  site: string | null;
  bodySide: VaccinationBodySide | null;
  doseVolume: number | null;
  doseUnit: string | null;
  lotNumber: string | null;
  expirationDate: string | null;
  manufacturer: string | null;
  administeredBy: string | null;
  location: string | null;
  fundingSource: string | null;
  visDate: string | null;
  visEditionDate: string | null;
  nextDueDate: string | null;
  reaction: string | null;
  note: string | null;
  source: string | null;
  externalId: string | null;
  createdById: string | null;
  updatedById: string | null;
  createdAt: string;
  updatedAt: string;
  createdBy: {
    id: string;
    firstName: string;
    lastName: string;
  } | null;
};

export type VaccinationListResponse = {
  data: VaccinationRecord[];
};

export type VaccineCatalogResponse = {
  data: VaccineCatalogItem[];
};

export function formatVaccinationDate(value?: string | null) {
  if (!value) return '-';
  return new Date(value).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' });
}
